import { render, staticRenderFns } from "./indexWap.vue?vue&type=template&id=7450c7c8&scoped=true"
import script from "./indexWap.vue?vue&type=script&lang=js"
export * from "./indexWap.vue?vue&type=script&lang=js"
import style0 from "./indexWap.vue?vue&type=style&index=0&id=7450c7c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7450c7c8",
  null
  
)

export default component.exports